<h2 mat-dialog-title>
  Two-Factor Verification
  <button type="button" mat-icon-button mat-dialog-close aria-label="Close dialog" class="dialog-close-btn">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<mat-dialog-content>
  <form [formGroup]="otpForm" autocomplete="off">
    <p class="mb-10" [innerHTML]="data?.message"></p>
    <div class="form-group">
      <label for="otp">Please enter the OTP below to proceed:</label>
      <input
        autocomplete="one-time-code"
        class="form-control show-validation invalid-value"
        id="otp"
        inputmode="numeric"
        maxlength="6"
        minlength="6"
        name="otp"
        formControlName="otp"
        title="Enter your 6 digit verification code"
        type="text"
        />
    </div>
    <p class="mb-10">
      Did not receive the code?
      <br />
      <button
        class="btn-link btn-resend"
        type="button"
        (click)="resendOTP()"
        [disabled]="resendTimeout || limitReached"
        style="padding: 0; border: 0"
        >
        @if (resending && !resendTimeout) {
          <mat-spinner [diameter]="14"></mat-spinner>
          <span>Requesting OTP</span>
        }
        @if (!resending && !resendTimeout) {
          <span>Resend</span>
        }
        @if (resendTimeout && !limitReached) {
          <span>{{ resendSecs }}</span>
        }
        @if (limitReached) {
          <span>Resend unavailable</span>
        }
      </button>
      <br />
      <span>
        Not your phone?
        <a href="mailto:contact&#64;playoctopus.com" id="otp-confirmation-email-link"> Email us.</a>
      </span>
    </p>
    @if (errText) {
      <p class="error validationerror mb-10" id="otp-error" [innerHTML]="errText"></p>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    mat-button
    class="btn btn-pink-filled"
    (click)="verify()"
    [disabled]="submitting || limitReached || !otpForm.valid"
    >
    @if (submitting) {
      <mat-spinner [diameter]="14"></mat-spinner>
    }
    @if (submitting) {
      <span>Verifying</span>
    }
    @if (!submitting) {
      <span>Verify OTP</span>
    }
  </button>
</mat-dialog-actions>
